import { render, staticRenderFns } from "./AnnouncementPreview.vue?vue&type=template&id=225fe31c&scoped=true"
import script from "./AnnouncementPreview.vue?vue&type=script&lang=js"
export * from "./AnnouncementPreview.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPreview.vue?vue&type=style&index=0&id=225fe31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225fe31c",
  null
  
)

export default component.exports